// ManufacturingCountryQuestion.jsx
import React from "react";
import { Autocomplete } from "@mui/material";
import PerlTextField from "../../../../shared/components/PerlTextField";
import PerlLabelMedium from "../../../../shared/components/PerlLabelMedium";
import { FB_PRICING_COUNTRIES, fbCountryError } from "../fbCostingDraft";

/**
 * ManufacturingCountryQuestion - Shared question component
 * Used by: F&B, Mechanical, Electronics, Packaging
 *
 * Autocomplete searchable dropdown for country selection
 */
export default function ManufacturingCountryQuestion({
  value,
  onChange,
  onAutoAdvance, // Auto-advance handler from ChatInterface
  autoAdvanceOnSelect = false, // Enable auto-advance on selection
  restrictToSupportedFbCountries = false,
}) {
  const countries = restrictToSupportedFbCountries ? FB_PRICING_COUNTRIES : [
    "Albania",
    "Argentina",
    "Australia",
    "Austria",
    "Belgium",
    "Bosnia",
    "Brazil",
    "Bulgaria",
    "Canada",
    "China",
    "Czech Republic",
    "Denmark",
    "Egypt",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hong Kong",
    "Hungary",
    "India",
    "Indonesia",
    "Ireland",
    "Italy",
    "Japan",
    "Luxembourg",
    "Malaysia",
    "Mauritius",
    "Mexico",
    "Morocco",
    "Netherlands",
    "New Zealand",
    "Philiphines",
    "Philippines",
    "Poland",
    "Portugal",
    "Romania",
    "Russia",
    "Saudi Arabia",
    "Serbia",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "South Africa",
    "South Korea",
    "Spain",
    "Sri Lanka",
    "Sweden",
    "Switzerland",
    "Taiwan",
    "Thailand",
    "Tunisia",
    "Turkey",
    "UAE",
    "United Kingdom",
    "USA",
    "Vietnam",
  ];
  const unsupportedCountry = restrictToSupportedFbCountries && Boolean(value)
    && !FB_PRICING_COUNTRIES.includes(value);
  const countryHelp = restrictToSupportedFbCountries
    ? (unsupportedCountry ? fbCountryError(value)
      : "Temporarily available: USA, Canada, Mexico, Germany, Japan, India and China. Labor references are disclosed provisional estimates, not company-approved rates.")
    : undefined;

  const handleChange = (event, newValue) => {
    onChange(newValue);
    if (autoAdvanceOnSelect && onAutoAdvance && newValue) {
      onAutoAdvance();
    }
  };

  return (
    <>
      <PerlLabelMedium sx={{ mb: 2, display: "block" }}>
        Select Manufacturing Country:
      </PerlLabelMedium>
      <Autocomplete
        // Retain the saved draft for correction; an unavailable country must
        // not become a selectable eighth option or a valid completed answer.
        value={unsupportedCountry ? null : value || null}
        onChange={handleChange}
        options={countries}
        fullWidth
        renderInput={(params) => <PerlTextField {...params} placeholder="Type to search..."
          error={unsupportedCountry} helperText={countryHelp} />}
      />
    </>
  );
}
